// Sale CPO Eligibility — the salesperson's declaration, at booking, for a sold item sold as Used.
//
// A shared constant rather than a prop or a deal-mixin entry, deliberately: unlike vehicleTypes
// (which varies — Wholesale filters Cpo out) this list never varies by dealer, subscriber or
// contract type, and 21 components render <book-deal-capture>, so threading a prop through them
// would be 21 edits and 21 chances for one to be missed. A missed parent would render an empty
// selector on a mandatory field.
//
// The { id, name } shape is what ButtonListSelector expects: it matches on `id` and renders `name`.
// `id` values mirror the backend Domain.Enums.DealSaleCpoEligibility, which starts at 1 so that a
// defaulted 0 can never read as a decided answer.
export const CPO_ELIGIBILITY_TYPES = Object.freeze([
  Object.freeze({ id: 1, name: 'CPO Eligible', altName: 'Eligible' }),
  Object.freeze({ id: 2, name: 'CPO Ineligible', altName: 'Ineligible' })
])

// The wire value is the enum member name, not the on-screen label.
export function cpoEligibilityToWireValue (selected) {
  return selected ? selected.altName : null
}

export function cpoEligibilityFromWireValue (value) {
  return CPO_ELIGIBILITY_TYPES.find(x => x.altName === value) || null
}
